export default () => {
  document.querySelector('.er_footer__inner__bottom__copyright__year').innerText = new Date().getFullYear();
};
